var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.937,
    height: 29.938,
    viewBox: "0 0 29.937 29.938",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_16",
    x: 0,
    y: 0,
    width: 29.937,
    height: 29.938,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.353
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(3 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3, -2)",
    filter: "url(#Path_16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16-2",
    "data-name": "Path 16",
    d: "M18.618,23.937H5.319A5.32,5.32,0,0,1,0,18.618v-1.33a1.33,1.33,0,1,1,2.66,0v1.33a2.66,2.66,0,0,0,2.66,2.66h13.3a2.66,2.66,0,0,0,2.66-2.66v-1.33a1.33,1.33,0,1,1,2.66,0v1.33a5.32,5.32,0,0,1-5.319,5.319Zm-6.649-5.32a1.326,1.326,0,0,1-.929-.378h0l0,0h0l0,0h0l0,0-5.319-5.32A1.33,1.33,0,0,1,7.59,11.028l3.049,3.049V1.33a1.33,1.33,0,1,1,2.66,0V14.078l3.049-3.049a1.33,1.33,0,0,1,1.881,1.881l-5.319,5.319,0,0h0l0,0h0l0,0h0l-.045.042a1.321,1.321,0,0,1-.367.232h0a1.324,1.324,0,0,1-.515.1Z",
    transform: "translate(3 2)",
    fill: "#fff"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e37a2a72d5dcb233aed4bd6160c9aae0.svg";
export { ForwardRef as ReactComponent };